import * as Yup from 'yup'
import moment from 'moment'
import { t } from 'i18next'
const dateFilterSchema = Yup.object().shape({
  dates: Yup.object().shape({
    changeType: Yup.string()
      .test('check-type-date-diff', 'test', function (value, ctx) {
        const { endDate, startDate } = this.parent

        const start = moment(startDate, 'DD.MM.YYYY', true)
        const end = moment(endDate, 'DD.MM.YYYY', true)

        switch (value) {
          case 'segment':
            const after_one_month = end.subtract(37, 'day')
            const afterDate = moment(
              after_one_month.format('DD.MM.YYYY'),
              'DD.MM.YYYY',
              true
            )

            const check = afterDate.isAfter(start)

            if (check) {
              return this.createError({
                path: 'dates.startDate',
                message: 'acquiring.maxPeriod',
              })
            }

            break
          case 'startDate':
            const startDate_one_month = start.add(37, 'day')
            const startDate_Date = moment(
              startDate_one_month.format('DD.MM.YYYY'),
              'DD.MM.YYYY',
              true
            )

            const startDate_check = startDate_Date.isBefore(end)

            if (startDate_check) {
              return this.createError({
                path: 'dates.endDate',
                message: 'acquiring.maxPeriod',
              })
            }

            break
          case 'endDate':
            const endDate_one_month = end.subtract(37, 'day')
            const endDateDate = moment(
              endDate_one_month.format('DD.MM.YYYY'),
              'DD.MM.YYYY',
              true
            )

            const endDate_check = endDateDate.isAfter(start)

            if (endDate_check) {
              return this.createError({
                path: 'dates.startDate',
                message: 'acquiring.maxPeriod',
              })
            }

            break
          default:
            break
        }

        return true
      })
      .optional(),
    startDate: Yup.string()
      .required('acquiring.startDateRequired')
      .test(
        'is-before-startDate',
        'acquiring.startDateAfter',
        function (value) {
          const { endDate } = this.parent

          if (!endDate || !value) {
            return true
          }

          const start = moment(value, 'DD.MM.YYYY', true)
          const end = moment(endDate, 'DD.MM.YYYY', true)

          return start.isSameOrBefore(end)
        }
      ),
    endDate: Yup.string()
      .required('acquiring.endDateRequired')
      .test('is-after-startDate', 'acquiring.endDateAfter', function (value) {
        const { startDate } = this.parent
        if (!startDate || !value) {
          return true
        }

        const start = moment(startDate, 'DD.MM.YYYY', true)
        const end = moment(value, 'DD.MM.YYYY', true)

        return end.isSameOrAfter(start)
      }),
  }),
  language: Yup.string().required()
})

export default dateFilterSchema
